export const AppRouteNames = {
  // Home
  home: {
    label: "ホーム",
    value: "home",
  },

  // Login
  login: {
    label: "ログイン",
    value: "login",
  },
  logout: {
    label: "ログアウト",
    value: "logout",
  },
  recover: {
    label: "新規登録",
    value: "recover",
  },
  resetPassword: {
    label: "パスワード再設定",
    value: "reset_password",
  },
  register: {
    label: "新規登録",
    value: "register",
  },

  // page not found
  pageNotFound: {
    label: "「ページが見つかりません」の画面",
    value: "page_not_found",
  },
  externalPageNotFound: {
    label: "「ページが見つかりません」の画面",
    value: "external_page_not_found",
  },
  serverErrorPage: {
    label: "サーバーエラーページ",
    value: "server_error_page",
  },

  // Maintenance
  maintenance: {
    label: "メンテナンス",
    value: "maintenance",
  },

  // Contact
  contact: {
    label: "お問い合わせ",
    value: "contact",
  },

  // Customer user management
  customerUsers: {
    label: "ユーザー管理",
    value: "customer_users",
  },
  customerUserCreate: {
    label: "ユーザー登録",
    value: "customer_user_create",
  },
  customerUserDetail: {
    label: "ユーザー情報",
    value: "customer_user_detail",
  },
  customerUserEdit: {
    label: "ユーザー情報",
    value: "customer_user_edit",
  },

  // User setting (ユーザー設定)
  userSettingDetail: {
    label: "ユーザー設定",
    value: "user_setting_detail",
  },
  userSettingEdit: {
    label: "ユーザー設定",
    value: "user_setting_edit",
  },
  userSettingChangeEmail: {
    label: "メールアドレス変更",
    value: "user_setting_change_email",
  },
};

export enum EProvidedLegalProtection {
  ONE = "one",
  TWO = "two",
  THREE = "three",
  FOUR = "four",
  FIVE = "five",
  SIX = "six",
  SEVEN = "seven",
}
